import { Dialog } from "@headlessui/react";
import Button from "../../../components/button/Button";
import { Modal, ModalProp } from "../../../components/modal/Modal";
import { ModalFoterBox, ModalHeaderBox, } from "../../../components/box/Box";
import { Company } from "../../../model/Companies";
import { useForm } from "react-hook-form";
import { Spiner } from "../../../components/spinner/Spiner";

export type UsersCountUpdateProps = {
  beforeUsersCount: number | undefined;
  afterUsersCount:  number | undefined;
  onSubmit: (data: Company) => Promise<void>;
  isLoad: boolean;
};

export const UsersCountUpdateConfirmationModal = ({
  open,
  toggle,
  closeOnClickOutside,
  beforeUsersCount,
  afterUsersCount,
  onSubmit,
  isLoad,
}: ModalProp & UsersCountUpdateProps) => {
  const { handleSubmit } = useForm<Company>();

  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <Dialog.Overlay>
        {
          <>
            {isLoad === true ?
              <Spiner /> : (
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
                  <form
                      className=""
                      onSubmit={handleSubmit(onSubmit)}
                      method="POST"
                      noValidate
                  >
                    <div className="px-2 pb-4 sm:p-4">
                      <div className="text-center sm:mt-3">
                        <ModalHeaderBox
                          title={"契約数が変更されています"}
                        />
                        <div className="text-left pl-5 mt-3">
                          <div>
                              {`契約数が変更されています。変更前：${beforeUsersCount} / 変更後：${afterUsersCount}`}
                          </div>
                          <div>
                              {'登録しますか？'}
                          </div>
                        </div>
                      </div>
                    </div>
                    <ModalFoterBox>
                      <Button
                        className="mr-2 w-[132px]"
                        outline
                        color={"indigo"}
                        onClick={toggle}
                        children={"キャンセル"}
                      />
                      <Button
                        submit
                        className="w-[132px]"
                        children={"登録"}
                      />
                    </ModalFoterBox>
                  </form>
                </Dialog.Panel>
              )}
          </>
        }
      </Dialog.Overlay>
    </Modal>
  );
};
